import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getMe } from './store/slices/authSlice';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import ContactCategories from './pages/ContactCategories';
import Templates from './pages/Templates';
import Campaigns from './pages/Campaigns';
import Users from './pages/Users';
import InstitutionContacts from './pages/InstitutionContacts';
import Footers from './pages/Footers';
import ActivityLogs from './pages/ActivityLogs';
import GmailInbox from './pages/GmailInbox';
import ComposeEmail from './pages/ComposeEmail';
import Profile from './pages/Profile';
import UserActivity from './pages/UserActivity';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import SuperAdminRoute from './components/SuperAdminRoute';
import OAuthHandler from './components/OAuthHandler';

function App() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      dispatch(getMe());
    }
  }, [dispatch, token]);

  return (
    <>
      <OAuthHandler />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="contact-categories" element={<SuperAdminRoute><ContactCategories /></SuperAdminRoute>} />
          <Route path="templates" element={<SuperAdminRoute><Templates /></SuperAdminRoute>} />
          <Route path="footers" element={<SuperAdminRoute><Footers /></SuperAdminRoute>} />
          <Route path="campaigns" element={<SuperAdminRoute><Campaigns /></SuperAdminRoute>} />
          <Route path="activity-logs" element={<SuperAdminRoute><ActivityLogs /></SuperAdminRoute>} />
          <Route path="gmail-inbox" element={<SuperAdminRoute><GmailInbox /></SuperAdminRoute>} />
          <Route path="compose-email" element={<SuperAdminRoute><ComposeEmail /></SuperAdminRoute>} />
          <Route path="profile" element={<Profile />} />
          <Route path="users" element={<SuperAdminRoute><Users /></SuperAdminRoute>} />
          <Route path="user-activity" element={<SuperAdminRoute><UserActivity /></SuperAdminRoute>} />
          <Route path="institution/:institutionType" element={<InstitutionContacts />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
